import axios from 'axios';
import type { ConnectionPhase } from '@/entities/connection-entity';

export type PanelStatusResponse = {
	ok: true;
	maintenance: boolean;
};

const panelStatusApi = axios.create({
	baseURL: import.meta.env.VITE_BACK_URL,
	timeout: 5000,
});

export function phaseFromPanelStatus(status: PanelStatusResponse): Extract<ConnectionPhase, 'online' | 'updating'> {
	return status.maintenance ? 'updating' : 'online';
}

export async function fetchPanelStatus(): Promise<PanelStatusResponse> {
	const res = await panelStatusApi.get<PanelStatusResponse>('/status');
	return res.data;
}